import {store} from '../../../store/store'
import page from '../../../components/page.vue'
import search from '../../../components/search.vue'
import  zixun from '../../../components/zixun.vue'
import {api} from "../../../common/config";
import {ajaxUtil} from '../../../common/AjaxUtil.js';
import {CommonUtil} from '../../../common/CommonUtil.js';
import {StorageUtil, LocalStorageUtil} from '../../../common/Auth.js';
export default {
  name:"activitylist",
  data(){
    return {
      type:store.webType,
        locationCode:'',
        pageCount:3,
        hallCode:'',
        pageNo:1,
        informationData:{},
        idS:[],
        totalPage:0,
    }

  },
  components:{
    page,
    search,
    zixun
  },

  beforeMount() {
    store.wrap.activeRouteName = '资讯';
    this.queryData();
  },

  watch:{
      $route() {
         this.queryData();
      }
  },

  methods:{
    queryData(){
        this.locationCode = this.$route.query.code || "510107";
        this.pageNo=this.$route.query.page || 1;
        this.hallCode = this.$route.query.libCode || this.$route.query.hallCode;
        var url;
        if(store.webType == 1) {
            url = api.library.libNews.replace('{libCode}', this.hallCode).replace('{pageNo}', this.pageNo).replace('{pageCount}', this.pageCount);
        } else {
            url = api.information.search.replace('{locationCode}', this.locationCode).replace('{pageCount}', this.pageCount).replace('{pageNo}', this.pageNo).replace('{keyword}', "");
        }
        ajaxUtil.ajaxJson(url, null, "GET", (data) => {
            this.informationData = data;
            this.totalPage=data.totalPage;
            if (this.informationData.resultList != null) {
                for (var i = 0; i < this.informationData.resultList.length; i++) {
                    this.idS.push(this.informationData.resultList[i].newsId);
                }
            }
        }, null, this);
    },



    paging: function (pageNo) {
      CommonUtil.mergeQuery(this,{page: pageNo})
    },
    toNewsInfo(newsId){
      var data={
        ids:this.idS,
        totalCount:this.informationData.totalCount,
        pageNo:this.pageNo,
        totalPage:this.informationData.totalPage,
        pageCount:this.informationData.pageCount,
      };
      StorageUtil.storeObject("informationInfo",data);
      this.$router.push({path: '/infordetails', query: {newsId: newsId, fromSearch: 0,code:this.locationCode,hallCode:this.hallCode}});
    },
    //点击搜索
    search(keywordInput) {
      var searchStr=keywordInput.trim();
      if(searchStr==""){
        this.$router.push('/');
        return;
      }
      this.$router.push({path: 'indexsearch', query: {searchStr: searchStr, type:5,code:store.chooseArea.code,fromSearch:1,hallCode: this.hallCode}});
    },
    highSearch(){
      this.$router.push({path: 'searchbook', query: {type: 1,"fromSearch":1,hallCode: this.hallCode, typeId:2}});
    }
  }
}
